import { T, useI18n } from '@tribeplatform/react-components/i18n'
import type { I18nShape } from '@tribeplatform/react-components/i18n'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

import { FileTypeBadge } from './FileTypeBadge.js'
import type { FileTypeWithTooltip } from './FileTypeBadge.js'

const defaultFileTypesFactory = (intl: I18nShape): FileTypeWithTooltip[] => {
  const { $t } = intl

  return [
    {
      type: 'image/*',
      toolTip: $t({
        id: 'Admin.MediaSettings.EnableAllImages',
        defaultMessage: 'Enable all image types',
      }),
    },
    {
      type: 'audio/*',
      toolTip: $t({
        id: 'Admin.MediaSettings.EnableAllAudios',
        defaultMessage: 'Enable all audio types',
      }),
    },
    {
      type: 'video/*',
      toolTip: $t({
        id: 'Admin.MediaSettings.EnableAllVideos',
        defaultMessage: 'Enable all video types',
      }),
    },
    {
      type: '.pdf',
      toolTip: $t({
        id: 'Admin.MediaSettings.EnablePdfFiles',
        defaultMessage: 'Enable PDF type',
      }),
    },
  ]
}

interface SuggestedFileTypesProps {
  fileTypes: string[]
  addFileType: (fileType: string) => void
}
export const SuggestedFileTypes = ({
  fileTypes,
  addFileType,
}: SuggestedFileTypesProps) => {
  const intl = useI18n()
  const defaultFileTypes = defaultFileTypesFactory(intl)
  const suggestedFileTypes = defaultFileTypes.filter(
    suggestedFileType =>
      !fileTypes.some(fileType => fileType === suggestedFileType.type),
  )

  if (suggestedFileTypes.length === 0) {
    return (
      <FormControl.HelperText>
        <T
          defaultMessage="By default, we support all video, image, audio, and pdf files."
          id="Admin.MediaSettings.DefaultSupportedFileTypes"
        />
      </FormControl.HelperText>
    )
  }

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <FormControl.HelperText>
        <T
          defaultMessage="Suggested file types:"
          id="Admin.MediaSettings.SuggestedFileTypes"
        />
      </FormControl.HelperText>
      <div className="flex space-x-2">
        {suggestedFileTypes.map(fileType => (
          <FileTypeBadge
            key={fileType.type}
            fileType={fileType}
            onClick={() => addFileType(fileType.type)}
          />
        ))}
      </div>
    </div>
  )
}
